import { styled } from "@mui/material/styles";
import { LoadingButton } from "@mui/lab";

const RoundButton = styled(LoadingButton)(() => ({
    borderRadius: 100
}));

export default RoundButton;